import { useLayoutEffect, useState } from "react";

const HEADING_SELECTOR = "h2, h3";

/** root の h2・h3 を出現順に返す。後から描画される見出し (料金ページの単価など) も DOM の変化を見て拾い直す。 */
export function useDocHeadings(root: HTMLElement | null): HTMLHeadingElement[] {
	const [headings, setHeadings] = useState<HTMLHeadingElement[]>([]);

	useLayoutEffect(() => {
		if (!root) {
			setHeadings([]);
			return;
		}
		const collect = () => {
			const next = Array.from(root.querySelectorAll<HTMLHeadingElement>(HEADING_SELECTOR));
			setHeadings((prev) =>
				prev.length === next.length && prev.every((h, i) => h === next[i]) ? prev : next,
			);
		};
		collect();
		const observer = new MutationObserver(collect);
		observer.observe(root, { childList: true, subtree: true, characterData: true });
		return () => observer.disconnect();
	}, [root]);

	return headings;
}
